export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/sudoku.worker.f7e28c9f.worker.js");
}
